// extracted by mini-css-extract-plugin
module.exports = {"container":"_3OizFDy0P7stom9WFtCZna"};